import { render, staticRenderFns } from "./merchantWithdrawAddRecord.vue?vue&type=template&id=318b0150&scoped=true"
import script from "./merchantWithdrawAddRecord.vue?vue&type=script&lang=ts"
export * from "./merchantWithdrawAddRecord.vue?vue&type=script&lang=ts"
import style0 from "./merchantWithdrawAddRecord.vue?vue&type=style&index=0&id=318b0150&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318b0150",
  null
  
)

export default component.exports